import { render, staticRenderFns } from "./InputDrawer.vue?vue&type=template&id=b02b5c60"
import script from "./InputDrawer.vue?vue&type=script&lang=js"
export * from "./InputDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports